type CsvUploadNameSource = {
  id: string;
  fileUrl: string;
  fileName?: string | null;
};

/**
 * The name to show for a CSV upload. Batch uploads record the file name the
 * user chose; older uploads only have the S3 URL, whose last path segment is
 * the name with an upload timestamp appended.
 */
export function csvUploadFileName(upload: CsvUploadNameSource): string {
  if (upload.fileName) return upload.fileName;
  try {
    const name = new URL(upload.fileUrl).pathname.split("/").pop();
    if (name) return decodeURIComponent(name);
  } catch {
    // Fall through to the id for a URL that cannot be parsed.
  }
  return upload.id.slice(0, 8);
}
